export enum DisplayOnlyFormFields {
  MileageBetweenOriginDestination = 'mileageBetweenOrigDest',
  ScheduleTripCode = 'scheduleTripCode',
  OrigToDestMileage = 'origToDestMileage',
  TotalMileage = 'totalMileage',
  HazmatOverrideInd = 'hazmatOverrideInd',
}
